import React from 'react';

/**
 * SmartButton — bouton de navigation contextuel style Odoo.
 *
 * Props:
 *   icon      : ReactNode  — icône Lucide
 *   label     : string     — libellé
 *   count     : number     — compteur affiché en badge
 *   onClick   : fn
 *   color     : 'blue' | 'orange' | 'green' | 'purple' (défaut: 'blue')
 */
const COLORS = {
  blue:   { bg: '#EFF6FF', border: '#BFDBFE', text: '#1D4ED8', badge: '#1D4ED8' },
  orange: { bg: '#FFF7ED', border: '#FED7AA', text: '#C2410C', badge: '#C2410C' },
  green:  { bg: '#F0FDF4', border: '#BBF7D0', text: '#15803D', badge: '#15803D' },
  purple: { bg: '#F5F3FF', border: '#DDD6FE', text: '#7C3AED', badge: '#7C3AED' },
};

export function SmartButton({ icon, label, count, onClick, color = 'blue' }) {
  const c = COLORS[color] || COLORS.blue;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`smart-btn-${label.toLowerCase().replace(/\s+/g, '-')}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 12px 4px 8px',
        borderRadius: 20,
        border: `1px solid ${c.border}`,
        background: c.bg,
        cursor: 'pointer',
        fontSize: 12,
        fontWeight: 700,
        color: c.text,
        whiteSpace: 'nowrap',
        transition: 'opacity 0.15s, box-shadow 0.15s',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        lineHeight: 1,
      }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.12)'}
      onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)'}
    >
      {icon && <span style={{ display: 'flex', alignItems: 'center' }}>{icon}</span>}
      <span>{label}</span>
      {count !== undefined && count !== null && (
        <span style={{
          background: c.badge,
          color: '#fff',
          borderRadius: 9999,
          padding: '1px 7px',
          fontSize: 11,
          fontWeight: 700,
          minWidth: 18,
          textAlign: 'center',
          lineHeight: 1.6,
        }}>
          {count}
        </span>
      )}
    </button>
  );
}
